import HotelIcon from "jsx:../../../Images/Icons/FontAwesome/solid/hotel.svg";
import LocationArrowIcon from "jsx:../../../Images/Icons/FontAwesome/solid/location-arrow.svg";
import * as React from "react";
import { GroupTypeEnum } from "../../Pages/GroupDetailsPage/Group.types";

const icons: any[string] = [];
icons[GroupTypeEnum.HOTEL] = <HotelIcon fill={"#FFFFFF50"} />;
icons[GroupTypeEnum.HOLIDAY_HOME] = <HotelIcon fill={"#FFFFFF50"} />;
icons[GroupTypeEnum.CITY] = <LocationArrowIcon fill={"#FFFFFF50"} />;
icons[GroupTypeEnum.REGION] = <LocationArrowIcon fill={"#FFFFFF50"} />;
icons[GroupTypeEnum.COUNTRY] = <LocationArrowIcon fill={"#FFFFFF50"} />;
icons[GroupTypeEnum.REGION_GROUP] = <LocationArrowIcon fill={"#FFFFFF50"} />;

export const Icons = icons;

export const getGroupTypeIcon = (type: string | null) => {
    if (type === null) {
        return Icons[GroupTypeEnum.REGION];
    }

    return Icons[type] ?? Icons[GroupTypeEnum.REGION];
};
